module.exports = __webpack_public_path__ + "img/jeze.6e94f14f.jpg";